import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../services/api';

export const fetchTradeHistory = createAsyncThunk(
  'tradeHistory/fetchTradeHistory',
  async (params = {}) => {
    const response = await api.get('/api/trade-history/', { params });
    return response.data;
  }
);

export const fetchTradeStatistics = createAsyncThunk(
  'tradeHistory/fetchStatistics',
  async (params = {}) => {
    const response = await api.get('/api/trade-history/statistics/', { params });
    return response.data;
  }
);

export const fetchTradeExchangePairs = createAsyncThunk(
  'tradeHistory/fetchExchangePairs',
  async () => {
    const response = await api.get('/api/trade-history/exchange_pairs/');
    return response.data;
  }
);

const tradeHistorySlice = createSlice({
  name: 'tradeHistory',
  initialState: {
    trades: [],
    count: 0, // Total count for pagination
    statistics: {
      total_trades: 0,
      buy_trades: 0,
      sell_trades: 0,
      total_volume: 0,
      total_volume_usdt: 0,
      total_fees: 0,
      avg_price: 0,
    },
    exchangePairs: [], // Available exchange pairs for filtering
    loading: false,
    error: null,
    filters: {
      start_date: null,
      end_date: null,
      side: null,
      trading_pair: null,
      trigger: null,
    },
  },
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTradeHistory.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchTradeHistory.fulfilled, (state, action) => {
        state.loading = false;
        state.trades = action.payload.results || action.payload;
        state.count = action.payload.count || (action.payload.results ? action.payload.results.length : action.payload.length);
      })
      .addCase(fetchTradeHistory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchTradeStatistics.fulfilled, (state, action) => {
        state.statistics = action.payload;
      })
      .addCase(fetchTradeExchangePairs.fulfilled, (state, action) => {
        state.exchangePairs = action.payload;
      });
  },
});

export const { setFilters } = tradeHistorySlice.actions;
export default tradeHistorySlice.reducer;